import {IContentMapper} from "../base.content";
import {cmsTypeToString} from "../../constants";
import {MapContent, MapContentDTO} from "../map.content";

export class MapContentMapper implements IContentMapper {
  toDTO(data: MapContent): MapContentDTO {
    return {
      type: cmsTypeToString(data.type),
      lat: data.lat,
      lon: data.lng
    };
  }

  fromDTO(data: MapContentDTO): MapContent {
    return new MapContent({
      lat: data.lat,
      lng: data.lon
    });
  }

}



// WEBPACK FOOTER //
// ./src/api/club-cms/content/mappers/map.ts